/**
 * <PostalSearchBox /> — one component, every market.
 *
 * Wraps the per-market search boxes (IeEircodeSearchBox / UkPostcodeSearchBox)
 * and picks the right one from useMarket(). This is the abstraction that
 * lets callers forget which market they're in:
 *
 *     <PostalSearchBox variant="light" />
 *
 * In USA we'll later mount a ZipSearchBox here too — no caller changes.
 */
import React from 'react';
import IeEircodeSearchBox from './IeEircodeSearchBox';
import UkPostcodeSearchBox from './UkPostcodeSearchBox';
import UsZipSearchBox from './UsZipSearchBox';
import { useMarket } from '../hooks/useMarket';

const PostalSearchBox = ({ country, ...props }) => {
  const { isUK, isUS } = useMarket(country);
  if (isUS) return <UsZipSearchBox variant={props.variant} {...props} />;
  if (isUK) return <UkPostcodeSearchBox variant={props.variant} {...props} />;
  return <IeEircodeSearchBox variant={props.variant} {...props} />;
};

export default PostalSearchBox;
